import { Tenant } from '@eview/core/models/tenant';

export interface TenantState {
  tenant: Tenant;
}

export const initialTenantState: TenantState = {
  tenant: null
};
